// Cloudflare R2 Image Upload Service

import { WORKER_URL } from '../config/worker';

/**
 * Şəkili Cloudflare R2-yə upload edir
 * @param {File} file - Upload ediləcək şəkil
 * @param {string} folder - R2-də folder adı (məs: 'products', 'stores', 'banners')
 * @returns {Promise<string>} - Public image URL
 */
export const uploadToR2 = async (file, folder = 'uploads') => {
  try {
    // Şəkil validasiyası
    if (!file.type.startsWith('image/')) {
      throw new Error('Yalnız şəkil faylları yüklənə bilər');
    }

    // Maksimum 5MB
    if (file.size > 5 * 1024 * 1024) {
      throw new Error('Şəkil ölçüsü 5MB-dan çox ola bilməz');
    }

    // FormData yaratmaq
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    // Cloudflare Worker-ə upload et
    const response = await fetch(`${WORKER_URL}/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Şəkil yüklənə bilmədi');
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Şəkil yüklənə bilmədi');
    }

    return result.publicUrl;
  } catch (error) {
    console.error('R2 upload error:', error);
    throw error;
  }
};

/**
 * Multiple şəkil upload
 * @param {FileList|File[]} files - Upload ediləcək şəkillər
 * @param {string} folder - Folder adı
 * @returns {Promise<string[]>} - Public URLs array
 */
export const uploadMultipleToR2 = async (files, folder = 'uploads') => {
  const fileArray = Array.from(files);
  const uploadPromises = fileArray.map(file => uploadToR2(file, folder));
  return Promise.all(uploadPromises);
};

/**
 * Image preview URL yaratmaq üçün helper
 * @param {File} file 
 * @returns {string} - Local preview URL
 */
export const createImagePreview = (file) => {
  return URL.createObjectURL(file);
};

// Alias for backwards compatibility
export const uploadImageToR2 = uploadToR2;
